import React from 'react'
import moment from 'moment'

import DatePicker from 'react-datepicker'
import TimePicker from 'rc-time-picker'

import 'rc-time-picker/assets/index.css'

export default ({
  value,
  onChange,
  disabled = false,
}) => {
  // date-picker expects a moment object
  let momentValue = typeof value === 'string' ? moment(value) : (value || null)

  return (
    <div>
      <DatePicker
        todayButton='Today'
        className='date-picker'
        placeholderText='Date'
        dateFormat='MM/DD/YY'
        selected={momentValue}
        onChange={date => handleDateChange(onChange, momentValue, date)}
        disabled={disabled}
      />
      <TimePicker
        showSecond={false}
        hideDisabledOptions
        placeholder='00:00'
        value={momentValue}
        format='h:mm a'
        use12Hours
        disabledMinutes={() => disabledMinutes}
        onChange={time => handleTimeChange(onChange, momentValue, time)}
        disabled={disabled}
      />
    </div>
  )
}

const disabledMinutes = Array.from({ length: 60 },
  (l, k) => ((k % 5 !== 0) ? k : undefined))
  .filter((val) => val !== undefined)

function handleDateChange (callback, initial, date) {
  date = date.clone()

  date.add(initial.hours(), 'hours')
  date.add(initial.minutes(), 'minutes')

  callback(date)
}

function handleTimeChange (callback, initial, time) {
  time.seconds(0)
  callback(time)
}



// WEBPACK FOOTER //
// ./src/components/forms/datetime-picker.js